<app-label-configuration
  [title]="'P0003606.installation.regulation' | translate"
  [titleListe]="'P0003606.installation.regulation.value' | translate"
  [value]="actionStack!.getValue('iphPConsigneRegulationPh')"
  [liste]="P0003606ConsigneRegulationPh"
  [information]="P0003606ESPInstallationPh"
  (onPress)="
    actionStack!.editValue(
      P00039DataRxTxIndex.InjectionPh_Parametrage,
      'iphPConsigneRegulationPh',
      $event
    );
    actionStack!.commit()
  "
>
</app-label-configuration>

@if (
  hasProduitP0003600() > 0 ||
  hasProduitP0003601() > 0 ||
  hasProduitP0004700() > 0 ||
  hasProduitP00046() > 0
) {
  <app-switch-configuration
    [nameCustom]="'P0003606.installation.filtration.value' | translate"
    [value]="actionStack!.getValue('iphIActivationFonctionAutoMaintien') !== 0"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.InjectionPh_Installation,
        'iphIActivationFonctionAutoMaintien',
        $event ? 1 : 0
      );
      actionStack!.commit()
    "
  >
  </app-switch-configuration>
}

<app-label-description
  [description]="'P0003606.installation.regulation.description' | translate"
></app-label-description>

<app-label-configuration
  [title]="'P0003606.installation.correcteur.title' | translate"
  [description]="'P0003606.installation.correcteur.description' | translate"
  [titleListe]="'P0003606.installation.correcteur' | translate"
  [value]="actionStack!.getValue('iphITypeCorrecteurPh')"
  [liste]="P0003606TypeCorrecteurPh"
  [information]="P0003606TypeCorrecteurPhModal"
  (onPress)="
    actionStack!.editValue(
      P00039DataRxTxIndex.InjectionPh_Installation,
      'iphITypeCorrecteurPh',
      $event
    );
    actionStack!.commit()
  "
>
</app-label-configuration>

<app-switch-configuration
  [title]="'P0003606.installation.protectionSurdosage' | translate"
  [nameCustom]="'P0003606.installation.protectionSurdosage.value' | translate"
  [value]="actionStack!.getValue('iphIActivationProtectionSurdosage') !== 0"
  [information]="EnSavoirPlusPage"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.InjectionPh_Installation,
      'iphIActivationProtectionSurdosage',
      $event ? 1 : 0
    );
    actionStack!.commit()
  "
>
</app-switch-configuration>

<app-label-configuration
  [titleListe]="'P0003606.parametrage.limiteSurdosage.value' | translate"
  [value]="actionStack!.getValue('iphPDureeLimiteSurdosage')"
  [liste]="P0003606DureeLimiteSurdosage"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.InjectionPh_Parametrage,
      'iphPDureeLimiteSurdosage',
      $event
    );
    actionStack!.commit()
  "
>
</app-label-configuration>

<app-label-description
  [description]="
    'P0003606.installation.protectionSurdosage.description' | translate
  "
></app-label-description>

@if (isSupportTechnique()) {
  <app-switch-configuration
    [title]="'P0003606.parametrage.securitePh' | translate"
    [nameCustom]="'P0003606.parametrage.securitePh.value' | translate"
    [description]="'P0003606.parametrage.securitePh.description' | translate"
    [value]="actionStack!.getValue('iphIActivationSecuritePh') !== 0"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.InjectionPh_Installation,
        'iphIActivationSecuritePh',
        $event ? 1 : 0
      );
      actionStack!.commit()
    "
  >
  </app-switch-configuration>
}
